__turbopack_context__.v({
  "button": "style-module-scss-module__7a7smG__button",
  "button_hidden": "style-module-scss-module__7a7smG__button_hidden",
  "item": "style-module-scss-module__7a7smG__item",
  "item_active": "style-module-scss-module__7a7smG__item_active",
  "label": "style-module-scss-module__7a7smG__label",
  "label_mb": "style-module-scss-module__7a7smG__label_mb",
  "slideInFromLeft": "style-module-scss-module__7a7smG__slideInFromLeft",
  "slideInFromTop": "style-module-scss-module__7a7smG__slideInFromTop",
  "subtitle": "style-module-scss-module__7a7smG__subtitle",
  "subtitle_hidden": "style-module-scss-module__7a7smG__subtitle_hidden",
  "title": "style-module-scss-module__7a7smG__title",
  "title_hidden": "style-module-scss-module__7a7smG__title_hidden",
});
